import PropTypes from 'prop-types';

const propertyTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.node,
  category: PropTypes.string,
  insertedAt: PropTypes.node,
  labels: PropTypes.arrayOf(PropTypes.string),
  memberAccess: PropTypes.bool,
  withPageMargins: PropTypes.bool,
  showLoader: PropTypes.bool,
  memberAccessLabelText: PropTypes.string,
};

export default propertyTypes;
